// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--background-overlay);
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

:host([open]) {
    display: flex;
}

.swiftref-dialog {
    display: flex;
    opacity: 0;
    background: var(--background-default);
    border-radius: var(--spacing-05);
    width: 500px;
    max-width: 90%;
    max-height: 90vh;
    flex-direction: column;
    position: relative;
    /*--effects-medium-x: 0;*/
    /*--effects-medium-y: 3px;*/
    /*--effects-medium-blur: 4px;*/
    /*--effects-medium-spread: 3px;*/
    /*--effects-shadow-default: rgba(25, 115, 103, 0.1500);*/

    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /*box-shadow: var(--effects-medium-x) var(--effects-medium-y) var(--effects-medium-blur) var(--effects-medium-spread) var(--effects-shadow-default);*/
    /*animate from right*/
    /*transform: translateX(70vw);*/
    transition: transform .2s ease-in-out, opacity .2s ease-in-out;
}
:host([auto_width]) .swiftref-dialog {
    width: auto;
    max-width: 80%;
    min-width: 840px;
}

.swiftref-dialog.animate {
    transform: translateX(0);
    opacity: 1;
}

.swiftref-dialog header {
    padding: 0  var(--spacing-20);
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.swiftref-dialog .dialog-content {
    padding: var(--spacing-40) var(--spacing-20);
    flex: 1;
}
/*in case if custom dropdown, add scrollbar,
and consequently do non allow to open dropdown to overflow the dialog content */
:host(:not([small])) .swiftref-dialog .dialog-content {
    overflow-y: auto;
}

.swiftref-dialog .dialog-footer {
    padding: var(--spacing-20);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-20);
    align-items: flex-end;
}

.swiftref-dialog .close-icon {
    font-family: var(--font-family), sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: var(--icon-light);
    cursor: pointer;
    width: 20px;
    height: 20px;
}


:host(:not([title_icon])) swiftref-icon {
    display: none;
}

:host([kind="compact"]) .swiftref-dialog #dialog-title:empty {
    display: none;
}
:host([kind="compact"]:not([message])) .swiftref-input swiftref-message {
    margin-top: 0;
    display: none;
}

@media (max-width: 768px) {
    .swiftref-dialog {
        width: 96%;
        max-width: 100%;
        height: 96vh;
        max-height: 100vh;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/dialog/style/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,qCAAqC;IACrC,gCAAgC;IAChC,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,wDAAwD;;IAExD,wCAAwC;IACxC,qJAAqJ;IACrJ,qBAAqB;IACrB,+BAA+B;IAC/B,8DAA8D;AAClE;AACA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;;AAGA;IACI,4CAA4C;IAC5C,OAAO;AACX;AACA;+EAC+E;AAC/E;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[":host {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--background-overlay);\n    display: none;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n:host([open]) {\n    display: flex;\n}\n\n.swiftref-dialog {\n    display: flex;\n    opacity: 0;\n    background: var(--background-default);\n    border-radius: var(--spacing-05);\n    width: 500px;\n    max-width: 90%;\n    max-height: 90vh;\n    flex-direction: column;\n    position: relative;\n    /*--effects-medium-x: 0;*/\n    /*--effects-medium-y: 3px;*/\n    /*--effects-medium-blur: 4px;*/\n    /*--effects-medium-spread: 3px;*/\n    /*--effects-shadow-default: rgba(25, 115, 103, 0.1500);*/\n\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    /*box-shadow: var(--effects-medium-x) var(--effects-medium-y) var(--effects-medium-blur) var(--effects-medium-spread) var(--effects-shadow-default);*/\n    /*animate from right*/\n    /*transform: translateX(70vw);*/\n    transition: transform .2s ease-in-out, opacity .2s ease-in-out;\n}\n:host([auto_width]) .swiftref-dialog {\n    width: auto;\n    max-width: 80%;\n    min-width: 840px;\n}\n\n.swiftref-dialog.animate {\n    transform: translateX(0);\n    opacity: 1;\n}\n\n.swiftref-dialog header {\n    padding: 0  var(--spacing-20);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n\n.swiftref-dialog .dialog-content {\n    padding: var(--spacing-40) var(--spacing-20);\n    flex: 1;\n}\n/*in case if custom dropdown, add scrollbar,\nand consequently do non allow to open dropdown to overflow the dialog content */\n:host(:not([small])) .swiftref-dialog .dialog-content {\n    overflow-y: auto;\n}\n\n.swiftref-dialog .dialog-footer {\n    padding: var(--spacing-20);\n    display: flex;\n    justify-content: flex-end;\n    gap: var(--spacing-20);\n    align-items: flex-end;\n}\n\n.swiftref-dialog .close-icon {\n    font-family: var(--font-family), sans-serif;\n    font-weight: bold;\n    font-size: 16px;\n    color: var(--icon-light);\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n}\n\n\n:host(:not([title_icon])) swiftref-icon {\n    display: none;\n}\n\n:host([kind=\"compact\"]) .swiftref-dialog #dialog-title:empty {\n    display: none;\n}\n:host([kind=\"compact\"]:not([message])) .swiftref-input swiftref-message {\n    margin-top: 0;\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .swiftref-dialog {\n        width: 96%;\n        max-width: 100%;\n        height: 96vh;\n        max-height: 100vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
